import React from 'react';
import { I18n, Trans } from 'react-i18next';
import $ from 'jquery';
import { Form, Text } from 'react-form';



export class NewsLetter extends React.Component {

  
  render() {
   
    return (
     <I18n ns="translations">
        {
          (t, { i18n }) => (
             <div className="row padded-sections text-center">
                <div id="bottom-form" className="col-md-offset-3 col-md-6 col-sm-6 col-xs-12">
                  <Form>
                  <form className="form-inline" action="https://hapiwine.us18.list-manage.com/subscribe/post?u=12e0ac3ac51a40ab4a53f0f43&amp;id=ae43db2dc1" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"  target="_blank" novalidate>
                    <div className="form-group">
                        <label htmlFor="inputText">{t('footernews')}</label>
                        <Text type="email" value="" field="EMAIL" name="EMAIL" placeholder="email address" required="true" className="form-control" id="inputText" />
                        <a className="form-arrow" href="#" onClick={()=> {$('#mc-embedded-subscribe-form').submit();}}><img src="images/ic-white_arrow.png"/></a>
                      </div>
                  </form>
                  </Form>
                </div>
              </div>      
             )
          }
      </I18n>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer/NewsLetter/NewsLetter.js